$(function () {

    $('.flip-image-container.has-flip').on('click', function () {

        if($(window).width() < 768) $(this).toggleClass('mobile-flip-click');

    });

    // let teamMemberSliders = $('.team-member-fun-slider').slick({
    //
    // });

    // $('.flip-image-container').on('hover', function () {
    //     teamMemberSliders.refresh();
    // });

    $(".team-member-fun-slider").each(function () {

        let slider = $(this),
            nextArrow = $(this).find('.fun-slider-next'),
            prevArrow = $(this).find('.fun-slider-prev'),
            totalSlides = $(this).data('slide-count'),
            currentSlide = 0;

        prevArrow.on('click', function (e) {

            e.stopPropagation();

            let prevSlideIndex = (currentSlide === 0) ? (totalSlides - 1) : (currentSlide - 1),
                prevSlide = slider.find('.team-member-fun-slide-' + prevSlideIndex);

            currentSlide = prevSlideIndex;

            slider.find('.team-member-fun-slide').not(prevSlide).addClass('hiding');
            prevSlide.removeClass('hiding');

        });

        nextArrow.on('click', function (e) {

            e.stopPropagation();

            let nextSlideIndex = (currentSlide === (totalSlides - 1)) ? 0 : (currentSlide + 1),
                nextSlide = slider.find('.team-member-fun-slide-' + nextSlideIndex);

            currentSlide = nextSlideIndex;

            slider.find('.team-member-fun-slide').not(nextSlide).addClass('hiding');
            nextSlide.removeClass('hiding');

        });

    });

});
